import ExpandMore from "@mui/icons-material/ExpandMore";
import { Button, Divider, Menu, MenuList } from "@mui/material";
import { Dispatch, SetStateAction, useContext, useState, createContext } from "react";

import {
  AddFulfillmentNoteMenuItem,
  AddFulfillmentNoteDialog_ as AddFulfillmentNoteDialog,
} from "./AddFulfillmentNote";
import { AssignMenuItem, BulkAssignDialog, UnassignMenuItem } from "./Assign";
import { ManageWorkflowTags, ManageWorkflowTagsDialog } from "./ManageWorkflowTags";
import { SetPortalToManual, SetPortalToAuto } from "./Portal";
import { RequeueDialog, RequeueMenuItem } from "./Requeue";
import { ResetReportsMenuItem, ResetReportsModal } from "./ResetReports";
import { WorkflowActivitiesRow } from "./types";

const buttonId = "workflow-activities-bulk-actions-button";
const menuId = "workflow-activities-bulk-actions-menu";

type DialogState =
  | "assign"
  | "manageTags"
  | "manageWorkflowTags"
  | "verify&submit"
  | "resetReports"
  | "requeue"
  | "addFulfillmentNote"
  | null;

const bulkActionContext = createContext<{
  selectedRows: WorkflowActivitiesRow[];
  dialogState: DialogState;
  setDialogState: Dispatch<SetStateAction<DialogState>>;
  onClose: () => void;
  clearSelection: () => void;
}>({
  selectedRows: [],
  dialogState: null,
  setDialogState: () => {},
  onClose: () => {},
  clearSelection: () => {},
});

export function useBulkActionContext() {
  return useContext(bulkActionContext);
}

export function BulkActionsMenu({
  selectedRows,
  onClearSelection,
}: {
  selectedRows: WorkflowActivitiesRow[];
  onClearSelection: () => void;
}) {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [dialogState, setDialogState] = useState<DialogState>(null);
  const open = Boolean(anchorEl);

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const onClose = () => {
    setAnchorEl(null);
    setDialogState(null);
  };

  return (
    <bulkActionContext.Provider
      value={{
        selectedRows,
        onClose,
        dialogState,
        setDialogState,
        clearSelection: onClearSelection,
      }}
    >
      <Button
        id={buttonId}
        size="medium"
        aria-controls={open ? menuId : undefined}
        aria-haspopup="true"
        aria-expanded={open ? "true" : undefined}
        disabled={!selectedRows.length}
        variant="contained"
        color="staff"
        onClick={handleClick}
        endIcon={<ExpandMore />}
      >
        Bulk Actions
      </Button>
      <Menu
        id={menuId}
        anchorEl={anchorEl}
        open={open}
        onClose={onClose}
        MenuListProps={{ "aria-labelledby": buttonId }}
      >
        <MenuList>
          <AssignMenuItem />
          <UnassignMenuItem />
          <Divider />
          <SetPortalToManual />
          <SetPortalToAuto />
          <Divider />
          <RequeueMenuItem />
          <Divider />
          <ResetReportsMenuItem />
          <Divider />
          <ManageWorkflowTags />
          <Divider />
          <AddFulfillmentNoteMenuItem />
        </MenuList>
      </Menu>
      <BulkAssignDialog />
      <ManageWorkflowTagsDialog />
      <RequeueDialog />
      <ResetReportsModal />
      <AddFulfillmentNoteDialog />
    </bulkActionContext.Provider>
  );
}
